import {DefaultService} from "@/services/DefaultService";
import API from "@/plugins/axios";

class PredialService extends DefaultService{

    constructor() {
        super('predial');
    }

    generarEdoCuenta(locacion: any, data: any): Promise<any>{
        return API.request({
            url: `${this.url}/generarEdoCuenta/${locacion}`,
            data: data,
            method: 'POST',
            responseType: 'blob'
        })
    }

    getRegistros(filters: any): Promise<any> {
        let query = new URLSearchParams(filters).toString().replace(/null/g, '');
        return API.get(`${this.url}/getRegistros?${query}`);
    }

    getValuacionClaveCatastral(data: any): Promise<any> {
        return API.post(`${this.url}/getValuacionClaveCatastral`, data);
    }

    generarEdoCuentaDesglosado(locacion: any, data: any): Promise<any>{
        return API.request({
            url: `${this.url}/generarEdoCuentaDesglosado/${locacion}`,
            data: data,
            method: 'POST',
            responseType: 'blob'
        })
    }

    getPagosPredialByClave(data: any): Promise<any> {
        return API.post(`${this.url}/getPagosPredialByClave`, data);
    }

    getEstablecimientoCuentaByClave(data: any): Promise<any> {
        return API.post(`${this.url}/getEstablecimientoCuentaByClave`, data);
    }

    generarEdoCuentaAgrupado(data: any): Promise<any>{
        return API.request({
            url: `${this.url}/generarEdoCuentaAgrupado`,
            data: data,
            method: 'POST',
            responseType: 'blob'
        })
    }

    exportExcel(url: string = '', data: any = {}): Promise<any>{
        return API.request({
            url: url,
            data: data,
            method: 'POST',
            responseType: 'blob'
        })
    }

    getUltimoPagoPredial(data: any): Promise<any> {
        return API.post(`${this.url}/getUltimoPagoPredial`, data);
    }

    generarEdoCuentaSolicitudes(data: any): Promise<any>{
        return API.request({
            url: `${this.url}/generarEdoCuentaSolicitudes`,
            data: data,
            method: 'POST',
            responseType: 'blob'
        })
    }

    generarEdoCuentaDesglosadoSolicitud(data: any): Promise<any>{
        return API.request({
            url: `${this.url}/generarEdoCuentaDesglosadoSolicitud`,
            data: data,
            method: 'POST',
            responseType: 'blob'
        })
    }

    solicitarConvenioPredial(data: any): Promise<any> {
        return API.post(`${this.url}/solicitarConvenioPredial`, data);
    }

    generarEdoCuentaSolicitudesPublic(data: any): Promise<any>{
        return API.request({
            url: `predial-pbl/generarEdoCuentaSolicitudes`,
            data: data,
            method: 'POST',
            responseType: 'blob'
        })
    }

    generarEdoCuentaDesglosadoSolicitudPublic(data: any): Promise<any>{
        return API.request({
            url: `predial-pbl/generarEdoCuentaDesglosadoSolicitud`,
            data: data,
            method: 'POST',
            responseType: 'blob'
        })
    }
}

export default new PredialService;